import React from 'react';
import PropTypes from 'prop-types';
import {localizedMessage} from '../message/Message';
import root from 'window-or-global';
import GiftcardBannerStyled from './GiftcardBannerStyled';

interface Props {
  posaGiftCardRedeemUrl: string;
}

const GiftcardBanner = ({posaGiftCardRedeemUrl}: Props) => {
  const onClick = () => {
    root.location.href = posaGiftCardRedeemUrl;
  };
  return (
    <GiftcardBannerStyled className="giftcard-banner">
      <img
        className="giftcard-image"
        alt="giftcard"
        src="https://cdn2.unrealengine.com/fn-giftcard-07b20928806c.svg"
      />
      <div className="giftcard-callout row">
        <div className="col-sm-8">
          <h2>{localizedMessage('epic.code.redemption.posa.giftcard.title')}</h2>
        </div>
        <div className="col-sm-4 redeem-btn">
          <button onClick={onClick} className="btn btn-primary">
            {localizedMessage('epic.common.redeem')}
          </button>
        </div>
      </div>
    </GiftcardBannerStyled>
  );
};

GiftcardBanner.propTypes = {
  posaGiftCardRedeemUrl: PropTypes.string,
};

export default GiftcardBanner;
